import { API_BASE, createFetchOptions } from './config'
import type { LeadListResponse, LeadDetailResponse, LeadUpdateRequest } from '@/types/leads'

export const leadsApi = {
  // Get all leads with filters
  async getLeads(params?: { page?: number; limit?: number; status?: string }) {
    const searchParams = new URLSearchParams()
    if (params?.page) searchParams.append('page', params.page.toString())
    if (params?.limit) searchParams.append('limit', params.limit.toString())
    if (params?.status) searchParams.append('status', params.status)

    const response = await fetch(
      `${API_BASE}/api/admin/leads?${searchParams}`,
      createFetchOptions()
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch leads: ${response.statusText}`)
    }

    return response.json() as Promise<LeadListResponse>
  },

  // Get single lead with interactions
  async getLead(id: number) {
    const response = await fetch(
      `${API_BASE}/api/admin/leads/${id}`,
      createFetchOptions()
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch lead: ${response.statusText}`)
    }

    return response.json() as Promise<LeadDetailResponse>
  },

  // Update lead status
  async updateLead(id: number, data: LeadUpdateRequest) {
    const response = await fetch(
      `${API_BASE}/api/admin/leads/${id}`,
      createFetchOptions({
        method: 'PATCH',
        body: JSON.stringify(data),
      })
    )

    if (!response.ok) {
      throw new Error(`Failed to update lead: ${response.statusText}`)
    }

    return response.json()
  },

  // Export leads to CSV
  async exportLeads(status?: string) {
    const searchParams = new URLSearchParams()
    if (status) searchParams.append('status', status)
    searchParams.append('format', 'csv')

    const response = await fetch(
      `${API_BASE}/api/admin/leads/export?${searchParams}`,
      createFetchOptions()
    )

    if (!response.ok) {
      throw new Error(`Failed to export leads: ${response.statusText}`)
    }

    return response.blob()
  }
}